/* tslint:disable */
/* eslint-disable */
/**
 * Poolside API
 * Poolside API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AmlStatus,
    AmlStatusFromJSON,
    AmlStatusFromJSONTyped,
    AmlStatusToJSON,
} from './';

/**
 * 
 * @export
 * @interface ApiUpdateLimitedPartnerPersonRequest
 */
export interface ApiUpdateLimitedPartnerPersonRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiUpdateLimitedPartnerPersonRequest
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof ApiUpdateLimitedPartnerPersonRequest
     */
    lastName: string;
    /**
     * 
     * @type {AmlStatus}
     * @memberof ApiUpdateLimitedPartnerPersonRequest
     */
    amlStatus: AmlStatus;
    /**
     * 
     * @type {string}
     * @memberof ApiUpdateLimitedPartnerPersonRequest
     */
    residency: string;
}

export function ApiUpdateLimitedPartnerPersonRequestFromJSON(json: any): ApiUpdateLimitedPartnerPersonRequest {
    return ApiUpdateLimitedPartnerPersonRequestFromJSONTyped(json, false);
}

export function ApiUpdateLimitedPartnerPersonRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiUpdateLimitedPartnerPersonRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'amlStatus': AmlStatusFromJSON(json['amlStatus']),
        'residency': json['residency'],
    };
}

export function ApiUpdateLimitedPartnerPersonRequestToJSON(value?: ApiUpdateLimitedPartnerPersonRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'firstName': value.firstName,
        'lastName': value.lastName,
        'amlStatus': AmlStatusToJSON(value.amlStatus),
        'residency': value.residency,
    };
}

